import { useState, useEffect } from 'react';
import { isNull, isUndefined } from 'lodash';

// TODO: expand this functionality / harden a bit
export const useLocalStorage = <T>(key: string, initialValue?: T) => {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }
    } catch (error) {
      console.log(error);
      return initialValue;
    }

    return initialValue;
  });

  useEffect(() => {
    // NOTE: this is a fallback in case a initialValue is not provided thus setting the localstorage value to `undefined`
    if (!isNull(state) && !isUndefined(state)) {
      try {
        window.localStorage.setItem(key, JSON.stringify(state));
      } catch (error) {
        console.log(error);
      }
    }
  }, [state, key]);

  return [state, setState];
};
